import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { updateProjectManagementDetails } from "../http/requests/project-management";
import {
  setVtrackLoader,
} from "../redux/actions";
import { getProjectManagementData, ProjectManagementType } from "../redux/actions/project-management";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerUpdateProjectManagementSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(updateProjectManagementDetails, payload.data);
    toast.success("Data Saved", toastOptions)
    let page=payload.data.pageNo;page+=1;
    let rows=payload.data.rows;
    yield put(
        getProjectManagementData({
        projectId: payload.data.projectId, 
        pageNo: page,
        pageSize: rows,
        sortDir: "ASC",
        sortBy: "projectName",
        searchData: "",
        billStatus:"",
        expiredAllocations: false
      })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err.data.errorMessage, toastOptions)
    yield put(setVtrackLoader(false));
  }
}

export function* updateProjectManagementSaga() {
  yield takeLatest(
    ProjectManagementType.UPDATE_PROJECT_MANAGEMENT_DATA,
    workerUpdateProjectManagementSaga
  );
}
